import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useNavigate, useParams } from 'react-router-dom'; // Use useNavigate for React Router v6
import { Career } from 'app/shared/model/career.model';
import { getCareersByType } from 'app/api/careerApi'; // Import the Career interface

const CareerTable: React.FC = () => {
  const [careers, setCareers] = useState<Career[]>([]);
  const { careerType } = useParams<{ careerType: string }>(); // Capture careerType from URL
  const navigate = useNavigate(); // useNavigate instead of useHistory
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getCareersByType(careerType)
      .then(response => {
        setCareers(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching career data:', error);
        setLoading(false);
      });
  }, [careerType]);

  // Redirect to the edit form (mask)
  const editCareer = (career: Career) => {
    navigate(`/edit-career/${career.id}`); // Use navigate instead of history.push
  };

  const actionBodyTemplate = (rowData: Career) => {
    return <Button icon="pi pi-pencil" rounded outlined className="mr-2" onClick={() => editCareer(rowData)} />;
  };

  return (
    <div className="career-table">
      <h2>{careerType === '1' ? 'Stará kariéra' : 'Nová kariéra'}</h2>
      <DataTable stripedRows sortField="positionNr" sortOrder={1} loading={loading} value={careers} responsiveLayout="scroll">
        <Column field="positionNr" header="Poradie" sortable></Column>
        <Column field="position" header="Pozícia" sortable></Column>
        <Column field="positionValue" header="Hodnota pozície (EUR)" sortable></Column>
        <Column field="percents" header="Percentá" sortable></Column>
        <Column field="promotionCondition" header="Podmienky postupu" sortable></Column>
        <Column header="Akcie" body={actionBodyTemplate}></Column>
      </DataTable>
    </div>
  );
};

export default CareerTable;
